export enum EmailSendingStatusEnum {
  Sent = 'sent',
  Failed = 'failed',
  NotSent = 'not_sent',
  Delivered = 'delivered',
  Opened = 'opened',
  Clicked = 'clicked'
}
